<template>
  <div class="bk-clipboard-item-video">
    <img v-if="imgUrl" :src="imgUrl" />
    <div>
      <div>
        <Icon :name="icon" />
        <h3>{{ providerLabel }}</h3>
      </div>
      <p>{{ data }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from "#imports";
import { Icon } from "#blokkli/components";
const props = defineProps({
  type: { type: String, required: true },
  id: { type: String, required: true },
  itemBundle: { type: String, required: true },
  data: { type: String, required: true },
  additional: { type: String, required: false },
  videoService: { type: null, required: true },
  videoId: { type: String, required: true }
});
const imgUrl = computed(() => {
  if (props.videoService === "youtube") {
    return `http://i3.ytimg.com/vi/${props.videoId}/hqdefault.jpg`;
  }
  return null;
});
const icon = computed(() => {
  switch (props.videoService) {
    case "youtube":
      return "youtube";
    case "vimeo":
      return "vimeo";
    case "tiktok":
      return "tiktok";
  }
  return "video-outline";
});
const providerLabel = computed(() => {
  switch (props.videoService) {
    case "youtube":
      return "YouTube";
    case "vimeo":
      return "Vimeo";
    case "tiktok":
      return "TikTok";
  }
  return props.videoService || "Video";
});
</script>
